// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__hAXzk","button":"BookNowBtn_button__lUG2y"};